import webhookicon from "../../../icons/webhook-48.png";
import AngleBracketsIcon from '@atlaskit/icon/core/angle-brackets'
import { ActionType } from "../../interfaces/flow/action/ActionType";
export const ActionUIRenderType = {
  WEB_ACTION: "WEB_ACTION",
  SCRIPT_ACTION_TYPE: ActionType.SCRIPT_ACTION_TYPE
};
export const ActionRenderOptions = [
  {
    label: (
      <div>
        <img src={webhookicon} width="20" height="20"></img>&nbsp;Web Action
      </div>
    ),
    value: ActionUIRenderType.WEB_ACTION,
    title: "Web Action",
  },
  {
    label: (
      <div>
        <span className="create-dropdown-icon"><AngleBracketsIcon label="" /></span>&nbsp;Script Action
      </div>
    ),
    value: ActionUIRenderType.SCRIPT_ACTION_TYPE,
    title: "Script Action",
  }
];
